import { createAppStore } from '@renenet/shared/src/store'

const store = createAppStore(
  typeof window !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : undefined
)

export default store
